export default "__VITE_ASSET__BUaUgGoV__"